// one icon per Shopify object type, shared by the sidebar and the theme's split-by-template
// headings so the same object looks the same everywhere
import LocalOfferOutlined from '@mui/icons-material/LocalOfferOutlined';
import FilterNoneOutlined from '@mui/icons-material/FilterNoneOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import MenuBookOutlined from '@mui/icons-material/MenuBookOutlined';
import ArticleOutlined from '@mui/icons-material/ArticleOutlined';

export const SECTION_ICONS = {
  products: LocalOfferOutlined,
  collections: FilterNoneOutlined,
  pages: DescriptionOutlined,
  blogs: MenuBookOutlined,
  articles: ArticleOutlined,
};
